import { letteredCmsItemBasesFromQuestion } from '../../cmsCasting';
import {
  collectLayoutUserVisibleText,
  layoutUserVisibleTextIncludes,
} from './collectLayoutUserVisibleText';
import type { LayoutNode } from './types';
import type { Question } from '../../types';
import { flattenQuestionTree } from '../../walkQuestionTree';

/**
 * Lettered CMS bases (e.g. `GG0100`) that have answer controls in the layout but no
 * matching literal in user-visible layout text (`static`, `section-label`, table
 * labels/headers, field `labelOverride`, etc.).
 */
export function computeMissingCmsVisibleLabels(
  sectionQuestions: Question[],
  layout: LayoutNode[],
  layoutFieldIds: ReadonlySet<string>
): string[] {
  const visibleChunks = collectLayoutUserVisibleText(layout);
  const basesWithControls = new Set<string>();

  for (const q of flattenQuestionTree(sectionQuestions)) {
    if (!layoutFieldIds.has(q.qid)) continue;
    const letteredBases = letteredCmsItemBasesFromQuestion({
      cms_casting: q.cms_casting,
    });
    for (const base of letteredBases) {
      basesWithControls.add(base);
    }
  }

  const missing: string[] = [];
  for (const base of basesWithControls) {
    if (!layoutUserVisibleTextIncludes(visibleChunks, base)) {
      missing.push(base);
    }
  }

  return missing.sort((a, b) => a.localeCompare(b));
}
